import { render, staticRenderFns } from "./sectionQuote.vue?vue&type=template&id=1a555cdd&scoped=true&"
import script from "./sectionQuote.vue?vue&type=script&lang=js&"
export * from "./sectionQuote.vue?vue&type=script&lang=js&"
import style0 from "./sectionQuote.vue?vue&type=style&index=0&id=1a555cdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a555cdd",
  null
  
)

export default component.exports